import { render, staticRenderFns } from "./snowBg.vue?vue&type=template&id=c040b16e&"
import script from "./snowBg.vue?vue&type=script&lang=ts&"
export * from "./snowBg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports